import useIsDesktop from "@hooks/useIsDesktop"

import useJobTimelineViewBryntumInstances from "./useJobTimelineViewBryntumInstances"

export default function useJobTimelineViewUIUtils() {
    const { schedulerPro } = useJobTimelineViewBryntumInstances()
    const isDesktop = useIsDesktop()

    const hideWeekendsFromScheduler = () => {
        try {
            const SATURDAY = 6
            const SUNDAY = 0

            const schedulerInstance = schedulerPro.current?.instance
            if (schedulerInstance) {
                schedulerInstance.suspendRefresh()

                void schedulerInstance.timeAxis.filterBy((tick: { startDate: { getDay: () => number } }) => {
                    const day = tick.startDate.getDay()
                    return day !== SATURDAY && day !== SUNDAY
                })

                void schedulerInstance.resumeRefresh()
                document.body.classList.add("bryntum-hide-weekends")
            }
        } catch (e) {
            console.error("Failed to hide weekends from scheduler", e)
        }
    }

    const showWeekendsOnScheduler = () => {
        try {
            const schedulerInstance = schedulerPro.current?.instance
            if (schedulerInstance) {
                schedulerInstance.suspendRefresh()

                void schedulerInstance.timeAxis.filterBy(() => true)

                void schedulerInstance.resumeRefresh()
                document.body.classList.remove("bryntum-hide-weekends")
            }
        } catch (e) {
            console.error("Failed to show weekends from scheduler", e)
        }
    }

    const hideEventFeedback = () => {
        const eventAddFeedback: HTMLElement | null = document.querySelector(".jsJobTimelineViewCreateJobIndicator")

        if (eventAddFeedback) {
            eventAddFeedback.style.display = "none"
        }
    }

    const showEventFeedback = () => {
        if (!schedulerPro.current) {
            return
        }

        const isResizing = schedulerPro.current.instance.features.eventResize.isResizing
        const isDragging = schedulerPro.current.instance.features.eventDrag.isDragging

        if (isResizing || isDragging || !isDesktop) {
            return hideEventFeedback()
        }

        const eventAddFeedback: HTMLElement | null = document.querySelector(".jsJobTimelineViewCreateJobIndicator")

        if (eventAddFeedback) {
            eventAddFeedback.style.display = "flex"
        }
    }

    const hideEventMoveFeedback = () => {
        const eventAddFeedback: HTMLElement | null = document.querySelector(".jsBryntumTimelineViewMoveFeedback")

        if (eventAddFeedback) {
            eventAddFeedback.classList.remove("job-timeline-view__job-moving-indicator--visible")
        }
    }

    const showEventMoveFeedback = ({
        isOverlapping,
        startDate,
        endDate,
        resourceId,
    }: {
        isOverlapping: boolean
        startDate: Date
        endDate: Date
        resourceId: string | number
    }) => {
        if (!schedulerPro.current) {
            return
        }

        const resourceTimeRangeStore = schedulerPro.current.instance.resourceTimeRangeStore as {
            getById(id: string | number): {
                id: string | number
                resourceId: string | number
                startDate: Date
                endDate: Date
                name: string
                cls: string
                setStartEndDate(startDate: Date, endDate: Date): void
            }
            add: (timeRange: {
                id: string | number
                resourceId: string | number
                startDate: Date
                endDate: Date
                name: string
                cls: string
            }) => void
        }

        const targetedTimeRange = resourceTimeRangeStore.getById("job-move-feedback")

        if (targetedTimeRange) {
            targetedTimeRange.setStartEndDate(startDate, endDate)
            targetedTimeRange.resourceId = resourceId

            const eventAddFeedback = document.querySelector(".jsBryntumTimelineViewMoveFeedback")

            eventAddFeedback?.classList?.add("job-timeline-view__job-moving-indicator--visible")

            if (eventAddFeedback && isOverlapping) {
                eventAddFeedback?.classList?.add("job-timeline-view__job-moving-indicator--overlapping")
            } else {
                eventAddFeedback?.classList?.remove("job-timeline-view__job-moving-indicator--overlapping")
            }
        }
    }

    return {
        hideEventFeedback,
        showEventFeedback,
        hideEventMoveFeedback,
        showEventMoveFeedback,
        hideWeekendsFromScheduler,
        showWeekendsOnScheduler,
    }
}
